import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { type RootState } from '@/redux/store';

import { AppRoute } from '../app/routes';

const useNavigateToErrorPage = (): void => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const errorStatusServer = useSelector(
    (state: RootState) => state.user.serverErrorStatus,
  );

  useEffect(() => {
    if (errorStatusServer) {
      navigate(AppRoute.ERRORPAGE);
    }
  }, [errorStatusServer, navigate, dispatch]);
};

export { useNavigateToErrorPage };
